const observer = new MutationObserver(function(mutationsList) {
     mutationsList.forEach(mutation => {
        console.log("Mutation type:", mutation.type);
        console.log("Target node:", mutation.target);
        if (mutation.type === "childList") {
            // console.log("Added nodes:", mutation.addedNodes);
            // console.log("Removed nodes:", mutation.removedNodes);
            // Hide New Created Variants from Modal and On product page from GLOBO APP rendering late
            hideItemByText('Item.no');
        }
    });
});

// Start observing the dialog box for child node additions
// const dialogBox = document.getElementById("Product-Modal-Content");
// observer.observe(dialogBox, { childList: true, attributes: true, });

const targetClasses = ['div.product-info']; // Add your class names here
const targets = document.querySelectorAll(targetClasses.join(', '));
targets.forEach(target => observer.observe(target, { childList: true, attributes: false, subtree: true}));

// HIde the items.no variants from quick-view
// Function to hide elements containing specific text
function hideItemByText(targetText) {
    // Get all elements with having text 'item.no'
    var items = document.querySelectorAll('label');
    // Loop through all items
    items.forEach(function(item) {
        if (item.textContent.includes(targetText)) {
            item.style.display = 'none';
        }
    });
}

hideItemByText('Item.no');